import './BisikletYarisiForm.css'
import { Button, Label, Input, Spinner, Modal, ModalBody, ModalFooter } from 'reactstrap'
import { useEffect, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import WarningModal from './WarningModal'
import Header from '../../Header'
import Loading from '../../Loading'
import ConditionsCheckBox from './ConditionsCheckBox'
import ReactMarkdown from 'react-markdown'
import axios from 'axios'

const KAN_GRUBU_OPTIONS = ['A Rh+', 'A Rh-', 'B Rh+', 'B Rh-', 'AB Rh+', 'AB Rh-', '0 Rh+', '0 Rh-']

const calculateAge = (birthDate) => {
  if (!birthDate) return null
  const today = new Date()
  const dob = new Date(birthDate)
  if (isNaN(dob.getTime())) return null
  let age = today.getFullYear() - dob.getFullYear()
  const m = today.getMonth() - dob.getMonth()
  if (m < 0 || (m === 0 && today.getDate() < dob.getDate())) age--
  return age
}

const DEFAULT_KATEGORILER = [
  { key: '6-8', min: 6, max: 8 },
  { key: '9-11', min: 9, max: 11 },
  { key: '12-14', min: 12, max: 14 },
]

const resolveCategory = (age, categories) => {
  if (age == null) return null
  const list = Array.isArray(categories) && categories.length ? categories : DEFAULT_KATEGORILER
  for (const k of list) {
    if (age >= k.min && age <= k.max) return k.key
  }
  return null
}

const cinsiyetLabel = (c) => (c === 'K' ? 'Kız' : c === 'E' ? 'Erkek' : '-')

const Row = ({ label, value, bold }) => (
  <div style={{ display: 'flex', justifyContent: 'space-between', gap: '0.5rem' }}>
    <span style={{ color: '#7a8a82' }}>{label}</span>
    <span style={{ fontWeight: bold ? 700 : 500, textAlign: 'right' }}>{value || '-'}</span>
  </div>
)

const BisikletYarisiForm = () => {
  const { state } = useLocation()
  const navigate = useNavigate()

  const [applicantType, setApplicantType] = useState('self')

  const [childName, setChildName] = useState('')
  const [childSurname, setChildSurname] = useState('')
  const [childTcNo, setChildTcNo] = useState('')
  const [childBirthDate, setChildBirthDate] = useState('')
  const [childCinsiyet, setChildCinsiyet] = useState('')

  const [veliAdi, setVeliAdi] = useState('')
  const [veliSoyadi, setVeliSoyadi] = useState('')
  const [veliTcNo, setVeliTcNo] = useState('')
  const [veliTelefonNo, setVeliTelefonNo] = useState('')

  const [bloodType, setBloodType] = useState('')

  const [checkbox, setCheckbox] = useState(false)
  const [loading, setLoading] = useState(false)
  const [isModal, setIsModal] = useState({ title: '', message: '', type: '', active: false })

  const [selfPreview, setSelfPreview] = useState(null)
  const [confirmModal, setConfirmModal] = useState({ open: false, data: null })

  useEffect(() => {
    axios
      .get(`${process.env.REACT_APP_BASE_URL}/api/dijital_basvuru/bisiklet-yarisi-preview`, {
        params: { id: state?.basvuruId },
        headers: {
          Authorization: 'Bearer ' + JSON.parse(localStorage.getItem('token')),
        },
      })
      .then((res) => {
        const data = res?.data || null
        setSelfPreview(data)
        const u = data?.uye
        if (u) {
          setVeliAdi((prev) => prev || u.adi || '')
          setVeliSoyadi((prev) => prev || u.soyadi || '')
          setVeliTcNo((prev) => prev || (u.tc || '').toString().replace(/\D/g, '').slice(0, 11))
          setVeliTelefonNo((prev) => prev || (u.telefon_no || '').toString().replace(/\D/g, '').slice(0, 10))
        }
      })
      .catch(() => setSelfPreview(null))
  }, [])

  const toggleWarningModal = (e) => {
    if (e?.stopPropagation) e.stopPropagation()
    setIsModal((prev) => ({ ...prev, active: !prev.active }))
  }

  const showError = (type, title, message) => {
    setIsModal({ type, title: title || '', message: message || '', active: true })
  }

  const onFinish = async (event) => {
    if (applicantType === 'child') {
      if (childName.trim().length < 2 || childSurname.trim().length < 2 || !childBirthDate || !childCinsiyet) {
        showError('failed_required')
        return
      }
      if (childTcNo.length !== 11) {
        showError('failed_tc')
        return
      }
    }

    if (!bloodType) {
      showError('failed_required')
      return
    }

    if (veliAdi.trim().length < 2 || veliSoyadi.trim().length < 2) {
      showError('failed_required', 'Veli Bilgileri Eksik', 'Veli adı ve soyadı zorunludur.')
      return
    }
    if (veliTcNo.length !== 11) {
      showError('failed_tc', 'Veli T.C. No Hatalı', 'Veli T.C. kimlik numarası 11 haneli olmalıdır.')
      return
    }
    if (veliTelefonNo.replace(/\D/g, '').length < 10) {
      showError('failed_required', 'Veli Telefonu Hatalı', 'Veli telefon numarası 10 haneli olmalıdır (başında 0 olmadan).')
      return
    }

    if (!checkbox) {
      showError('failed_agreement')
      return
    }

    let previewCinsiyet, previewKategori
    if (applicantType === 'self') {
      if (!selfPreview?.uygun) {
        showError('server_error', 'Başvuru Yapılamıyor', selfPreview?.mesaj || 'Profil bilgileriniz başvuru için yeterli değil.')
        return
      }
      previewCinsiyet = selfPreview.cinsiyet
      previewKategori = selfPreview.kategori
    } else {
      previewCinsiyet = childCinsiyet
      const age = calculateAge(childBirthDate)
      previewKategori = resolveCategory(age, selfPreview?.yaris?.kategoriler)
      if (!previewKategori) {
        showError('server_error', 'Yaş Uygun Değil', `Çocuğunuzun yaşı (${age ?? '-'}) ${selfPreview?.yaris?.yas_araligi || '6-14'} aralığında olmalıdır.`)
        return
      }
    }

    setConfirmModal({
      open: true,
      data: {
        applicantTypeLabel: applicantType === 'self' ? 'Kendi adıma' : 'Çocuğum adına',
        sporcuAdSoyad: applicantType === 'child' ? `${childName.trim()} ${childSurname.trim()}` : null,
        cinsiyetLabel: cinsiyetLabel(previewCinsiyet),
        kategori: previewKategori,
        bloodType,
        veliAdSoyad: `${veliAdi.trim()} ${veliSoyadi.trim()}`,
        veliTelefon: veliTelefonNo,
      },
    })
  }

  const submitToBackend = async () => {
    setLoading(true)

    const payload = {
      id: state?.basvuruId,
      applicant_type: applicantType,
      blood_type: bloodType,
      contract_approved: checkbox,
      veli: {
        adi: veliAdi.trim(),
        soyadi: veliSoyadi.trim(),
        tc_no: veliTcNo,
        telefon_no: veliTelefonNo.replace(/\D/g, ''),
      },
    }

    if (applicantType === 'child') {
      payload.child = {
        name: childName,
        surname: childSurname,
        tc_no: childTcNo,
        birth_date: childBirthDate,
        cinsiyet: childCinsiyet,
      }
    }

    try {
      const res = await axios.post(`${process.env.REACT_APP_BASE_URL}/api/dijital_basvuru/bisiklet-yarisi-create`, payload, {
        headers: {
          Authorization: 'Bearer ' + JSON.parse(localStorage.getItem('token')),
        },
      })

      if (res?.data?.code === 200) {
        navigate('/success-applications', { state: { id: res?.data?.result } })
      } else {
        showError('server_error', res?.data?.title || null, res?.data?.message || 'Bir hata oluştu.')
      }
    } catch (error) {
      showError('server_error', error.response?.data?.title || 'Sunucu Hatası', error.response?.data?.message || 'Bir hata oluştu')
    } finally {
      setLoading(false)
      setConfirmModal({ open: false, data: null })
    }
  }

  const inputStyle = {
    width: '90vw',
    borderRadius: '20px',
  }

  const labelStyle = {
    paddingLeft: '1.4rem',
    color: '#285843',
    fontWeight: 'bold',
    fontSize: '0.9rem',
  }

  const sectionTitleStyle = {
    paddingLeft: '1.4rem',
    color: '#285843',
    fontWeight: 'bold',
    fontSize: '1rem',
    marginTop: '1rem',
    marginBottom: '0.25rem',
  }

  return (
    <>
      {loading ? (
        <Loading formText={'Başvurunuz alınıyor,'} text={'Lütfen bekleyiniz...'} formLodading={true} />
      ) : (
        <div className='hide-scrollbar'>
          <div style={{ backgroundColor: '#fff', position: 'sticky', top: 0 }}>
            <Header onClick={() => navigate(-1)} />
          </div>

          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            <img src={'https://app.yanibasimdakaratay.com/uploads/dijital_basvurular/' + state?.basvuru_fotografi} alt='' width={'90%'} style={{ borderRadius: '10px' }} />
          </div>

          <div
            style={{
              display: 'flex',
              justifyContent: 'center',
              textAlign: 'center',
              marginTop: '1rem',
              marginBottom: '0.5rem',
              paddingLeft: '1rem',
              paddingRight: '1rem',
              paddingBottom: '0.5rem',
              fontSize: '0.9rem',
              fontStyle: 'italic',
              color: '#285843',
            }}
          >
            {state?.basvuru_aciklamasi}
          </div>

          <Label style={labelStyle}>Başvuru Türü</Label>
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              gap: '0.4rem',
              marginLeft: '1rem',
              marginRight: '1rem',
              marginBottom: '0.5rem',
            }}
          >
            {[
              { value: 'self', label: 'Kendi adıma başvuruyorum' },
              { value: 'child', label: 'Çocuğum adına başvuruyorum' },
            ].map((opt) => {
              const selected = applicantType === opt.value
              return (
                <label
                  key={opt.value}
                  htmlFor={`applicant-type-${opt.value}`}
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: '0.6rem',
                    padding: '0.6rem 0.9rem',
                    borderRadius: '14px',
                    border: '1px solid ' + (selected ? '#285843' : '#d8d8d0'),
                    backgroundColor: selected ? '#eef5f1' : '#fff',
                    color: '#285843',
                    cursor: 'pointer',
                    transition: 'border-color 0.2s ease, background-color 0.2s ease',
                  }}
                >
                  <input
                    id={`applicant-type-${opt.value}`}
                    type='radio'
                    name='applicantType'
                    value={opt.value}
                    checked={selected}
                    onChange={(e) => setApplicantType(e.target.value)}
                    style={{ accentColor: '#285843', width: '1.05rem', height: '1.05rem' }}
                  />
                  <span style={{ fontSize: '0.95rem', fontWeight: selected ? 600 : 400 }}>{opt.label}</span>
                </label>
              )
            })}
          </div>

          {applicantType === 'self' && selfPreview && (
            <div
              style={{
                marginTop: '0.75rem',
                marginLeft: '1rem',
                marginRight: '1rem',
                padding: '0.75rem',
                borderRadius: '12px',
                backgroundColor: selfPreview.uygun ? '#eef5f1' : '#fdecea',
                border: '1px solid ' + (selfPreview.uygun ? '#285843' : '#d9534f'),
                color: selfPreview.uygun ? '#285843' : '#7a1f1a',
                fontSize: '0.8rem',
                lineHeight: 1.4,
              }}
            >
              {selfPreview.uygun ? (
                <>
                  <strong>Kategoriniz:</strong> {selfPreview.kategori_etiketi}
                  <div style={{ marginTop: '0.3rem' }}>
                    Kalan asil: <strong>{selfPreview.kalan_asil}</strong> · Kalan yedek: <strong>{selfPreview.kalan_yedek}</strong>
                  </div>
                  {selfPreview.kontenjan_doldu && (
                    <div style={{ marginTop: '0.3rem', color: '#7a1f1a' }}>
                      <strong>Uyarı:</strong> Bu kategoride kontenjan dolmuştur.
                    </div>
                  )}
                </>
              ) : (
                <><strong>Uyarı:</strong> {selfPreview.mesaj}</>
              )}
            </div>
          )}

          {applicantType === 'child' && (
            <>
              <div style={sectionTitleStyle}>Çocuk Bilgileri</div>

              <Label style={labelStyle}>Ad</Label>
              <Input style={inputStyle} className='inputStyle' value={childName} onChange={(e) => setChildName(e.target.value)} />

              <Label style={labelStyle}>Soyad</Label>
              <Input style={inputStyle} className='inputStyle' value={childSurname} onChange={(e) => setChildSurname(e.target.value)} />

              <Label style={labelStyle}>T.C. Kimlik No</Label>
              <Input style={inputStyle} className='inputStyle' value={childTcNo} maxLength={11} inputMode='numeric' onChange={(e) => setChildTcNo(e.target.value.replace(/\D/g, ''))} />

              <Label style={labelStyle}>Doğum Tarihi</Label>
              <Input style={inputStyle} className='inputStyle' type='date' value={childBirthDate} onChange={(e) => setChildBirthDate(e.target.value)} />

              <Label style={labelStyle}>Cinsiyet</Label>
              <Input style={inputStyle} className='inputStyle' type='select' value={childCinsiyet} onChange={(e) => setChildCinsiyet(e.target.value)}>
                <option value=''>Seçiniz</option>
                <option value='E'>Erkek</option>
                <option value='K'>Kız</option>
              </Input>
            </>
          )}

          <div style={sectionTitleStyle}>Veli Bilgileri</div>

          <Label style={labelStyle}>Veli Adı</Label>
          <Input style={inputStyle} className='inputStyle' value={veliAdi} onChange={(e) => setVeliAdi(e.target.value)} />

          <Label style={labelStyle}>Veli Soyadı</Label>
          <Input style={inputStyle} className='inputStyle' value={veliSoyadi} onChange={(e) => setVeliSoyadi(e.target.value)} />

          <Label style={labelStyle}>Veli T.C. Kimlik No</Label>
          <Input
            style={inputStyle}
            className='inputStyle'
            value={veliTcNo}
            maxLength={11}
            inputMode='numeric'
            onChange={(e) => setVeliTcNo(e.target.value.replace(/\D/g, ''))}
          />

          <Label style={labelStyle}>Veli Telefon No</Label>
          <Input
            style={inputStyle}
            className='inputStyle'
            value={veliTelefonNo}
            maxLength={10}
            inputMode='numeric'
            placeholder='5XXXXXXXXX'
            onChange={(e) => {
              const cleaned = e.target.value.replace(/\D/g, '').replace(/^0+/, '')
              setVeliTelefonNo(cleaned.slice(0, 10))
            }}
          />

          <Label style={{ ...labelStyle, marginTop: '0.75rem' }}>{applicantType === 'child' ? 'Çocuk Kan Grubu' : 'Kan Grubu'}</Label>
          <Input style={inputStyle} className='inputStyle' type='select' value={bloodType} onChange={(e) => setBloodType(e.target.value)}>
            <option value=''>Seçiniz</option>
            {KAN_GRUBU_OPTIONS.map((k) => (
              <option key={k} value={k}>
                {k}
              </option>
            ))}
          </Input>

          <div
            style={{
              marginTop: '0.75rem',
              marginLeft: '1rem',
              marginRight: '1rem',
              padding: '0.75rem',
              borderRadius: '12px',
              backgroundColor: '#eef5f1',
              border: '1px solid #285843',
              color: '#285843',
              fontSize: '0.75rem',
              lineHeight: 1.4,
            }}
          >
            Yaş kategorisi (<strong>{(selfPreview?.yaris?.kategoriler || DEFAULT_KATEGORILER).map((k) => k.key).join(' / ')}</strong>) doğum tarihine göre otomatik belirlenir. Erkek ve Kız kategorileri ayrı değerlendirilir; her kategori için <strong>{selfPreview?.yaris?.asil_limit ?? 100} asil + {selfPreview?.yaris?.yedek_limit ?? 20} yedek</strong> kontenjan bulunmaktadır. Başvurunuz alındığında sıra numaranız SMS ile tarafınıza bildirilecektir.
          </div>

          <div
            style={{
              marginTop: '0.75rem',
              marginLeft: '1rem',
              marginRight: '1rem',
              padding: '0.75rem',
              borderRadius: '12px',
              backgroundColor: '#fff8e1',
              border: '1px solid #f0c674',
              color: '#7a5d00',
              fontSize: '0.75rem',
              lineHeight: 1.4,
            }}
          >
            <strong>Yarış Bilgileri</strong>
            <ul style={{ paddingLeft: '1.1rem', marginTop: '0.4rem', marginBottom: 0 }}>
              <li>Yer: <strong>{selfPreview?.yaris?.yer || 'Karatay Belediyesi Trafik Parkı'}</strong></li>
              {selfPreview?.yaris?.tarih && <li>Tarih: <strong>{selfPreview.yaris.tarih}</strong></li>}
              {selfPreview?.yaris?.kesin_kayit && <li>Kesin kayıt (ıslak imza teslimi): <strong>{selfPreview.yaris.kesin_kayit}</strong></li>}
              {selfPreview?.yaris?.saat && <li>Yarış başlangıç saati: <strong>{selfPreview.yaris.saat}</strong></li>}
            </ul>
            <div style={{ marginTop: '0.4rem' }}>
              Sağlık beyanı ve veli muvafakatnamesi yarış günü kesin kayıt esnasında ıslak imzalı olarak teslim edilecektir.
            </div>
          </div>

          {selfPreview?.yaris?.detay && (
            <div
              className='yaris-detay-markdown'
              style={{
                marginTop: '0.75rem',
                marginLeft: '1rem',
                marginRight: '1rem',
                padding: '0.75rem',
                borderRadius: '12px',
                backgroundColor: '#eef5f1',
                border: '1px solid #285843',
                color: '#285843',
                fontSize: '0.75rem',
                lineHeight: 1.4,
              }}
            >
              <ReactMarkdown>{selfPreview.yaris.detay}</ReactMarkdown>
            </div>
          )}

          <ConditionsCheckBox
            checkbox={checkbox}
            setCheckbox={setCheckbox}
            basvuru_sartlari_aciklama={state?.basvuru_sartlari_aciklama}
            style={{
              display: 'flex',
              alignItems: 'flex-start',
              gap: '0.6rem',
              marginTop: '1rem',
              marginLeft: '1rem',
              marginRight: '1rem',
              padding: '0.75rem',
              borderRadius: '12px',
              backgroundColor: '#f7faf8',
              border: '1px solid #d8e5dc',
            }}
          />

          <div
            style={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              marginTop: '1rem',
              marginBottom: '2rem',
            }}
          >
            <Button
              block
              onClick={onFinish}
              style={{
                marginLeft: '1rem',
                marginRight: '1rem',
                backgroundColor: '#285843',
                border: 'none',
                borderRadius: '14px',
                padding: '0.75rem 1rem',
                fontWeight: 600,
                letterSpacing: '0.2px',
                boxShadow: '0 4px 14px rgba(40, 88, 67, 0.25)',
              }}
            >
              {loading ? <Spinner size={'sm'} /> : 'Başvuruyu Tamamla'}
            </Button>
          </div>
        </div>
      )}

      <WarningModal isModal={isModal.active} messageType={isModal.type} messageTitle={isModal?.title} errorMessage={isModal?.message} toggleWarningModal={toggleWarningModal} />

      <Modal isOpen={confirmModal.open} centered toggle={() => !loading && setConfirmModal({ open: false, data: null })}>
        <ModalBody style={{ padding: '1.4rem 1.4rem 0.6rem' }}>
          <div style={{ textAlign: 'center', marginBottom: '0.9rem' }}>
            <div style={{ fontWeight: 700, fontSize: '1.1rem', color: '#285843' }}>Başvuru Özeti</div>
            <div style={{ fontSize: '0.78rem', color: '#7a8a82', marginTop: '0.2rem' }}>
              Aşağıdaki bilgilerle başvurunuz kaydedilecektir
            </div>
          </div>

          {confirmModal.data && (
            <div
              style={{
                backgroundColor: '#f7faf8',
                border: '1px solid #d8e5dc',
                borderRadius: '12px',
                padding: '0.9rem 1rem',
                fontSize: '0.88rem',
                color: '#285843',
                lineHeight: 1.7,
              }}
            >
              <Row label='Başvuru Türü' value={confirmModal.data.applicantTypeLabel} />
              {confirmModal.data.sporcuAdSoyad && <Row label='Sporcu' value={confirmModal.data.sporcuAdSoyad} bold />}
              <Row label='Cinsiyet' value={confirmModal.data.cinsiyetLabel} />
              <Row label='Yaş Kategorisi' value={`${confirmModal.data.kategori} Yaş`} bold />
              <Row label='Kan Grubu' value={confirmModal.data.bloodType} />
              <hr style={{ margin: '0.6rem 0', borderColor: '#d8e5dc' }} />
              <Row label='Veli' value={confirmModal.data.veliAdSoyad} />
              <Row label='Veli Telefon' value={confirmModal.data.veliTelefon} />
            </div>
          )}

          <div
            style={{
              marginTop: '0.9rem',
              fontSize: '0.78rem',
              color: '#7a5d00',
              backgroundColor: '#fff8e1',
              border: '1px solid #f0c674',
              borderRadius: '10px',
              padding: '0.55rem 0.75rem',
              textAlign: 'center',
            }}
          >
            Bilgiler doğru mu? Başvurunuz bu şekilde kaydedilecek.
          </div>
        </ModalBody>
        <ModalFooter style={{ borderTop: 'none', padding: '0.6rem 1.2rem 1.2rem' }}>
          <Button
            onClick={() => setConfirmModal({ open: false, data: null })}
            disabled={loading}
            style={{
              flex: 1,
              backgroundColor: '#fff',
              color: '#285843',
              border: '1px solid #d8e5dc',
              borderRadius: '12px',
              padding: '0.65rem',
              fontWeight: 600,
            }}
          >
            Vazgeç
          </Button>
          <Button
            onClick={submitToBackend}
            disabled={loading}
            style={{
              flex: 1,
              backgroundColor: '#285843',
              border: 'none',
              borderRadius: '12px',
              padding: '0.65rem',
              fontWeight: 600,
              boxShadow: '0 4px 14px rgba(40, 88, 67, 0.25)',
            }}
          >
            {loading ? <Spinner size='sm' /> : 'Onayla'}
          </Button>
        </ModalFooter>
      </Modal>
    </>
  )
}

export default BisikletYarisiForm
